import { globalUserState } from "state";
import { isLocal } from "services/utils";

export * from "./graphqlClient";

export * from "./content";
export * from "./conversations";
export * from "./documents";
export * from "./passwordreset";
export * from "./personas";
export * from "./signup";
export * from "./system";
export * from "./tokens";
export * from "./usage";
export * from "./user";

export const baseUrl = isLocal() ? "http://localhost:20265" : "https://ganglion.machineintelligence.com";
export const frontendBaseUrl = isLocal() ? "http://localhost:53592" : "";

// This is backend's interface to the state system
export const getRefreshToken = () => globalUserState.peek().refreshToken;
export const getAccessToken = () => globalUserState.peek().accessToken;
export { setTokens, logout } from "state";

